import React from "react";
import { Trans, useTranslation } from "react-i18next";

import { Stack } from "../Stack";

interface FileInfoProps {
  allowedFileExtensions?: string[];
  maxMBFileSize?: number;
}

const FileInfo = (props: FileInfoProps) => {
  const { allowedFileExtensions, maxMBFileSize } = props;

  const { t } = useTranslation();

  return (
    <Stack justifyContent="space-between">
      {allowedFileExtensions && allowedFileExtensions?.length > 0 && (
        <small>{`${t(
          "shared:forms:input:file:dropzone:description"
        )} ${allowedFileExtensions?.join(", ")}`}</small>
      )}
      {maxMBFileSize && (
        <small>
          <Trans
            i18nKey={"shared:forms:input:file:dropzone:max_file_size"}
            values={{
              size: maxMBFileSize,
            }}
          />
          {` ${t("shared:forms:input:file:dropzone:file_mb")}`}
        </small>
      )}
    </Stack>
  );
};

export default FileInfo;
